import {useRef, useEffect} from 'react';
import {useChatMessages} from '../hooks/use-chat-messages';
import {uuid} from '@/interfaces';
import MessageBubble from './message-bubble';

interface Props {
    roomId: uuid;
}

export default function MessageList({roomId}: Props) {
    const {messages, loadOlder, loading, fullyLoaded} = useChatMessages(roomId);

    const topRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const stayAtBottom = useRef(true);

    const scrollToBottom = () => {
        if (containerRef.current)
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
    };

    const isNearBottom = () => {
        const c = containerRef.current;
        if (!c) return true;
        return c.scrollHeight - c.scrollTop - c.clientHeight < 120;
    };

    useEffect(scrollToBottom, [roomId]);

    useEffect(() => {
        if (stayAtBottom.current)
            scrollToBottom();
    }, [messages.length]);

    const onScroll = () => {
        const c = containerRef.current;
        if (!c) return;

        stayAtBottom.current = isNearBottom()

        if (loading || fullyLoaded) return;
        if (c.scrollTop < 120) {
            const prev = c.scrollHeight;
            loadOlder().then(() =>
                requestAnimationFrame(() => {
                    c.scrollTop =
                        c.scrollHeight - prev + c.scrollTop;
                }),
            );
        }
    };

    return (
        <div
            ref={containerRef}
            role="log"
            aria-label="Messages"
            onScroll={onScroll}
            className="flex-1 overflow-y-auto p-4 space-y-4 h-[calc(100vh-65px)]"
        >
            <div ref={topRef}/>

            {/* TODO: UI Improvements - SYN- */}
            {loading && <p className="text-xs text-center text-muted-foreground mb-8">Loading…</p>}
            {fullyLoaded && <p className="text-xs text-center text-muted-foreground mb-8">— Start of Conversation —</p>}

            {messages.map(m => (
                <MessageBubble key={m.id} msg={m}/>
            ))}
        </div>
    );
}